import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 21h6v-10a1 1 0 0 0 -1 -1h-4a1 1 0 0 0 -1 1z","key":"svg-0"}],["path",{"d":"M12 2l1.465 1.638a2 2 0 1 1 -3.015 .099z","key":"svg-1"}]]

const IconCandle = createReactComponent('outline', 'candle', 'Candle', __iconNode);

export default IconCandle;